const round2 = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

/** Mirrors the server's CouponDiscountCalculator for showing the price before submitting. */
export const applyDiscount = (rule, originalAmount) => {
  const original = round2(Number(originalAmount) || 0);
  const value = Number(rule?.discountValue);
  if (!rule || original <= 0 || !Number.isFinite(value)) {
    return { originalAmount: original, discountAmount: 0, finalAmount: original };
  }
  const cap = Number(rule.maxDiscountAmount) > 0 ? Number(rule.maxDiscountAmount) : Infinity;
  let discount = 0;
  if (rule.discountType === 'FIXED_PAYABLE') {
    discount = Math.max(0, original - Math.min(Math.max(value, 0), original));
  } else if (rule.discountType === 'FLAT') {
    discount = Math.min(Math.max(value, 0), original, cap);
  } else if (rule.discountType === 'PERCENTAGE') {
    discount = Math.min(original * Math.min(Math.max(value, 0), 100) / 100, original, cap);
  }
  discount = round2(discount);
  return { originalAmount: original, discountAmount: discount, finalAmount: round2(original - discount) };
};
